import type { SVGProps } from "react";
export interface PosMachineIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PosMachineIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PosMachineIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 16v-4.874H16a1.125 1.125 0 0 1 0-2.25h4.875V8A.875.875 0 0 0 20 7.125h-4a1.125 1.125 0 0 1 0-2.25h4A3.125 3.125 0 0 1 23.125 8v8A3.125 3.125 0 0 1 20 19.125h-4a1.125 1.125 0 0 1 0-2.25h4a.875.875 0 0 0 .875-.875"
      />
      <path
        fill={color}
        d="M14.874 5a1.874 1.874 0 0 0-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v14c0 1.035.84 1.875 1.875 1.875h8c1.035 0 1.874-.84 1.874-1.875zM6.125 9.875h5.75v-3.75h-5.75zm.75 8.625a1.376 1.376 0 0 1-2.742.14l-.008-.14.008-.14A1.375 1.375 0 0 1 5.5 17.124l.14.007c.694.07 1.235.656 1.235 1.368Zm3.5 0a1.375 1.375 0 0 1-2.743.14l-.007-.14.007-.14A1.376 1.376 0 0 1 9 17.124l.141.007c.693.07 1.233.656 1.233 1.368Zm3.5 0a1.376 1.376 0 0 1-2.743.14l-.008-.14.008-.14a1.376 1.376 0 0 1 1.368-1.235l.14.007c.694.07 1.236.656 1.236 1.368Zm-7-3.5a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141A1.374 1.374 0 0 1 5.5 13.625l.14.007c.694.07 1.235.656 1.235 1.369Zm3.5 0a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 9 13.625l.141.007a1.376 1.376 0 0 1 1.233 1.369Zm3.5 0a1.375 1.375 0 0 1-2.743.141l-.008-.14.008-.141a1.375 1.375 0 0 1 1.368-1.235l.14.007c.694.07 1.236.657 1.236 1.369Zm.25-5a2.125 2.125 0 0 1-2.124 2.125H6A2.126 2.126 0 0 1 3.874 10V6c0-1.173.952-2.125 2.125-2.125h6c1.174 0 2.124.952 2.124 2.125v4Zm3 9a4.125 4.125 0 0 1-4.126 4.125H5A4.125 4.125 0 0 1 .875 19V5A4.125 4.125 0 0 1 5 .875h8A4.125 4.125 0 0 1 17.124 5v14Z"
      />
    </svg>
  );
}
